import "./PasswordChangeFormFields.css";

import { Field, FormikErrors, FormikTouched, FormikValues } from "formik";
import { ref, string } from "yup";

import TextInput from "./customInputs/TextInput";

export const passwordMatchSchema = (required = true) => ({
  new_password1: required
    ? string().min(8).required("Password required").label("Password")
    : string(),
  new_password2: (required
    ? string()
        .min(8)
        .required("Password confirmation required")
        .label("Repeat Password")
    : string()
  )
    .oneOf([ref("new_password1"), undefined], "Passwords must match")
    .label("Repeat Password"),
});

export const PasswordRequirements = () => (
  <ul>
    <li>
      Your password can’t be too similar to your other personal information.
    </li>
    <li>Your password must contain at least 8 characters.</li>
    <li>Your password can't be a commonly used password.</li>
    <li>Your password can't be entirely numeric.</li>
  </ul>
);

interface PasswordChangeFormFieldsProps {
  handleChange: Function;
  errors: FormikErrors<FormikValues>;
  touched: FormikTouched<FormikValues>;
  labels?: boolean;
  placeholders?: boolean;
}

const PasswordChangeFormFields = (props: PasswordChangeFormFieldsProps) => {
  return (
    <>
      <Field
        name="new_password1"
        key="new_password1"
        className="PasswordChangeFormFields__input"
      >
        {({ field }: any) => (
          <TextInput
            className="PasswordChangeFormFields__input"
            label={props.labels && "New Password"}
            placeholder={props.placeholders && "New Password"}
            id="new_password1"
            type="password"
            autoComplete="new-password"
            {...field}
            onChange={props.handleChange}
          />
        )}
      </Field>
      <Field name="new_password2" key="new_password2">
        {({ field }: any) => (
          <TextInput
            className="PasswordChangeFormFields__input"
            label={props.labels && "Repeat New password"}
            placeholder={props.placeholders && "Re-enter new password"}
            id="new_password2"
            type="password"
            autoComplete="new-password"
            {...field}
            onChange={props.handleChange}
          />
        )}
      </Field>
      {props.errors.new_password1 && props.touched.new_password1 && (
        <div className="PasswordChangeFormFields__error">
          {props.errors.new_password1}
        </div>
      )}
      {props.errors.new_password2 && props.touched.new_password2 && (
        <div className="PasswordChangeFormFields__error">
          {props.errors.new_password2}
        </div>
      )}
    </>
  );
};

export default PasswordChangeFormFields;
